var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState } from 'react';
import { SignInWithProviderButton } from 'root/src/client/v2/auth/components/SignInWithProviderButton';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { ModalTitle } from 'root/src/client/v2/common/components/modal/ModalTitle';
import toast from 'react-hot-toast';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
export const UpgradePermissionsModal = (props) => {
    const [isAutoModeEnabled, setAutoModeEnabled] = useState(true);
    const modal = useModal();
    return (<ModalLayout className="gap-6">
			<ModalTitle>We need your permission</ModalTitle>
			{props.renderDescription
            && props.renderDescription(isAutoModeEnabled)}
			<div className="flex flex-col gap-4 items-center">
				<FormControlLabel control={(<Checkbox checked={isAutoModeEnabled} onChange={(_, isChecked) => {
                setAutoModeEnabled(isChecked);
            }}/>)} label={(<span className="text-sm">
							{isAutoModeEnabled ? props.autoLabel : props.manualLabel}
						</span>)}/>
				{isAutoModeEnabled ? (<SignInWithProviderButton scopeSet={props.scopeSet} provider={props.provider} popup={props.popup} popupOptions={{
                onSuccess: () => __awaiter(void 0, void 0, void 0, function* () {
                    modal.hide();
                    toast.success('Permissions successfully upgraded!');
                    if (props.onSuccess) {
                        yield props.onSuccess();
                    }
                }),
                onError: (error) => __awaiter(void 0, void 0, void 0, function* () {
                    console.error(error);
                    toast.error((error === null || error === void 0 ? void 0 : error.message) || 'Something went wrong!');
                    if (props.onError) {
                        yield props.onError();
                    }
                }),
            }}/>) : (<ButtonNew type="button" onClick={() => {
                modal.hide();
                if (props.onContinue) {
                    props.onContinue();
                }
            }}>
						Continue
					</ButtonNew>)}
			</div>
		</ModalLayout>);
};
